import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import './styles.css';

interface MinutesDisplayProps {
    minutes: number;
}

const formatMinutesToDuration = (minutes: number): string => {
    // Only format if minutes is positive
    if (minutes >= 0) {
        const totalSeconds = Math.round(minutes * 60);
        const mins = Math.floor(totalSeconds / 60);
        const secs = totalSeconds % 60;
        
        if (mins > 0 && secs > 0) {
            return `${mins}m ${secs}s`;
        } else if (mins > 0) {
            return `${mins}m`;
        } else {
            return `${secs}s`;
        }
    }
    return '';
};

const getErrorMessage = (errorCode: number): string => {
    switch (errorCode) {
        case -1:
            return 'Audio length could not be found.';
        case -2:
            return 'Audio file too short (min 5 seconds).';
        case -3:
            return 'Audio too long (max 10 min).';
        case -4:
            return 'File too large (max 50MB).';
        case -5:
            return 'File unreadable (format not supported or corrupted file).';
        default:
            return 'Unknown error';
    }
};

const MinutesDisplay: React.FC<MinutesDisplayProps> = ({ minutes }) => {
    if (minutes < 0) {
        return (
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip id={`error-tooltip-${minutes}`} className="minutes-display-tooltip">
                        {getErrorMessage(minutes)}
                    </Tooltip>
                }
            >
                <div
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        backgroundColor: '#d41117',
                        color: 'white',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        cursor: 'help',
                    }}
                >
                    !
                </div>
            </OverlayTrigger>
        );
    }

    return <span>{formatMinutesToDuration(minutes)}</span>;
};

export default MinutesDisplay;
